import { FileText, Link, Music, Presentation, Table, Video } from '@digital-twins/design-system/icons'

import { ENTITY_ICONS, studyEntityIcon } from '@/lib/icons/entityIcons'
import { cn } from '@/lib/utils'
// Accepted components → pages import (precedent: other shared components):
// the platform glyphs are owned by the Knowledge Hub social views.
import { SocialPlatformIcon } from '@/pages/KnowledgeHubPage/social/SocialPlatformIcon'

import { CitationDocType, CitationSource } from './citationSource'
import { SourceFavicon } from './sourceFavicon'

const DOC_TYPE_ICONS: Record<CitationDocType, typeof FileText> = {
  report: FileText,
  document: FileText,
  deck: Presentation,
  data: Table,
  video: Video,
  audio: Music,
  link: Link,
}

export interface SourceIconProps {
  source: Pick<CitationSource, 'kind' | 'hostname' | 'platform' | 'docType' | 'goalId'>
  className?: string
}

/** Favicon for web, platform glyph for social, a type glyph for everything else. Always grey. */
export function SourceIcon(props: SourceIconProps) {
  const { source, className } = props

  const iconClassName = cn('h-3 w-3 shrink-0 text-muted-foreground', className)

  if (source.kind === 'web') {
    return <SourceFavicon hostname={source.hostname ?? null} className={cn('h-3 w-3', className)} />
  }
  if (source.kind === 'social' && source.platform) {
    return <SocialPlatformIcon platform={source.platform} className={iconClassName} />
  }
  if (source.kind === 'study' || source.kind === 'run') {
    const Icon = studyEntityIcon(source.goalId)
    return <Icon className={iconClassName} aria-hidden />
  }
  if (source.kind === 'room') {
    const Icon = ENTITY_ICONS.room
    return <Icon className={iconClassName} aria-hidden />
  }
  if (source.kind === 'audience') {
    const Icon = ENTITY_ICONS.audience
    return <Icon className={iconClassName} aria-hidden />
  }
  if (source.kind === 'dataset') {
    const Icon = ENTITY_ICONS.dataset
    return <Icon className={iconClassName} aria-hidden />
  }
  if (source.kind === 'connector_record') {
    const Icon = ENTITY_ICONS.connector_record
    return <Icon className={iconClassName} aria-hidden />
  }
  if (source.kind === 'social') {
    const Icon = ENTITY_ICONS.social
    return <Icon className={iconClassName} aria-hidden />
  }
  const Icon = DOC_TYPE_ICONS[source.docType ?? 'document'] ?? FileText
  return <Icon className={iconClassName} aria-hidden />
}
